var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mysymptoms-main-container"},[_c('h1',[_vm._v("Page Not Found")]),_c('p',[_vm._v(" Sorry - the page you are looking for does not exist. ")]),_c('p',[_c('router-link',{attrs:{"to":{name: 'home'}}},[_vm._v("Home")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }